module.exports = __webpack_public_path__ + "static/media/_MIC2546.thumbnail.9ada4f0d.png";